export default {"src":"/_next/static/media/spinner.e54894ca.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};